import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print6',
  templateUrl: './print6.component.html',
  styleUrls: ['./print6.component.scss']
})
export class Print6Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
